<template>
	<section class="sector_container"><slot></slot></section>
</template>
<script setup lang="ts"></script>

<style lang="scss" scoped>
.sector_container {
	display: flex;
	flex-direction: column;
	gap: 2.4rem;
	font-size: var(--font-s-large);
	font-weight: var(--font-w-bold);
	line-height: 2.7rem;
	@media screen and (max-width: 768px) {
		padding: 0rem 2rem;
	}
}
</style>
